import { Component } from 'react'
import {
  DocumentEditorContainerComponent,
  Toolbar,
  WordExport,
  SfdtExport
} from '@syncfusion/ej2-react-documenteditor'
import cn from 'classnames'
import s from './WordEditor.scss'
import { Button } from 'reactstrap'
import { getSyncfusionBaseUrl } from 'utils/api'
import { InputContainer } from 'components/ideal-core-ui'

DocumentEditorContainerComponent.Inject(Toolbar, WordExport, SfdtExport)

class WordEditor extends Component {
  state = {
    saveEnabled: false,
    title: this.props.title || ''
  }

  componentDidMount() {
    this.setTimer()
    setTimeout(() => {
      this.props.template && this.container.documentEditor.open(this.props.template)
    }, 0)
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.template && this.props.template) {
      this.props.template && this.container.documentEditor.open(this.props.template)
    }
  }

  componentWillUnmount() {
    clearInterval(this.timer)
    this.container.documentEditor.destroy()
  }

  setTimer = () => {
    this.timer = setInterval(() => {
      this.state.saveEnabled && this.save()
    }, 1000 * 120)
  }

  save = cb => {
    this.setState({
      saveEnabled: false
    })
    const body = this.container.documentEditor.serialize()
    const { title } = this.state

    this.container.documentEditor.saveAsBlob('Docx').then(exportedDocument => {
      const reader = new FileReader()
      reader.readAsDataURL(exportedDocument)
      reader.onloadend = function () {
        const base64body = reader.result
        cb && cb(body, base64body, { title })
      }
    })
  }

  setRef = scope => {
    this.container = scope
    window.GlobalWordEditor = scope
  }

  enableSave = () => {
    clearInterval(this.timer)
    this.setTimer()
    this.setState({
      saveEnabled: true
    })
  }

  render() {
    return (
      <div className={cn(s.textEditorWrapper, this.props.className)}>
        {this.props.hasTitle && (
          <InputContainer
            type="text"
            style={{ display: 'inline', marginRight: '20px', position: 'relative', bottom: '5px' }}
            placeholder="Template Name"
            cb={value => {
              this.setState({
                title: value
              })
            }}
            text={this.state.title}
            classname={s.title}
            cy="word_editor_title_input"
          />
        )}
        {this.props.saveActions &&
          this.props.saveActions.map((button, index) => (
            <Button
              key={index}
              className={cn(s.saveBtn, {
                [button.className]: button.className
              })}
              onClick={() => {
                this.save(button.cb)
              }}
              disabled={button.enabled ? false : !this.state.saveEnabled}
              data-cy={button.cy}
            >
              {button.text}
            </Button>
          ))}
        <DocumentEditorContainerComponent
          id="container"
          ref={this.setRef}
          style={{ display: 'block' }}
          height={
            this.props.height || (this.props.hasTitle ? 'calc(100% - 120px)' : 'calc(100% - 70px)')
          }
          enableToolbar
          contentChange={this.enableSave}
          serviceUrl={getSyncfusionBaseUrl('/api/documenteditor/')}
        />
      </div>
    )
  }
}

export default WordEditor
